import AstroStaticPage from "@/common/components/AstroStaticPage";
import React from "react";
import { Data } from "./data";

const DharmaKarma = () => {
  return <AstroStaticPage data={Data} />;
};

export default DharmaKarma;
